import React, { useState, useEffect, useCallback } from "react";
import "./App.css";
import "./sass/index.scss";
import LayoutApp from "./component/global/Dashboard/Layout";
import SignIn from "./component/pages/Sign-in/SignIn";
import { Provider } from "react-redux";
import { store } from "./component/redux/store";

function App() {
  const [hasValidToken, setHasValidToken] = useState(false);

  const checkTokenValidity = useCallback(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setHasValidToken(true);
    } else {
      setHasValidToken(false);
    }
  }, []);

  useEffect(() => {
    checkTokenValidity();
  }, [checkTokenValidity]);

  const handleLoginSuccess = useCallback(() => {
    // 🔹 Giả lập sinh token và lưu
    const fakeToken = "token_" + Date.now();
    localStorage.setItem("token", fakeToken);
    console.log("Đã tạo token:", fakeToken);

    checkTokenValidity();
  }, [checkTokenValidity]);

  return hasValidToken ? (
    <Provider store={store}>
      <LayoutApp />
    </Provider>
  ) : (
    <SignIn onLoginSuccess={handleLoginSuccess} />
  );
}

export default App;
